export const api = {
    url: 'https://api.themoviedb.org/3',
    api_key: '?api_key=bc088fe71dd6571f1b571a32a23d025d',
    backdrop_route: 'https://image.tmdb.org/t/p/original/'
}